var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1000003346(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 106,
    viewBox: "0 0 260 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(-0.717792 0.696258 -0.717792 -0.696258 259.243 9.83429)",
    fill: "#D41D24"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(-0.717792 0.696258 -0.717792 -0.696258 192.332 9.83429)",
    fill: "#D41D24"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(-0.717792 0.696258 -0.717792 -0.696258 127.812 9.83429)",
    fill: "#D41D24"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(-0.717792 0.696258 -0.717792 -0.696258 60.9009 9.83429)",
    fill: "#D41D24"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(-0.717792 0.696258 -0.717792 -0.696258 259.243 95.9968)",
    fill: "#D41D24"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(-0.717792 0.696258 -0.717792 -0.696258 192.332 95.9968)",
    fill: "#D41D24"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(-0.717792 0.696258 -0.717792 -0.696258 127.812 95.9968)",
    fill: "#D41D24"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(-0.717792 0.696258 -0.717792 -0.696258 60.9009 95.9968)",
    fill: "#D41D24"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(-0.717792 0.696258 -0.717792 -0.696258 218.618 51.9554)",
    fill: "#D41D24"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(-0.717792 0.696258 -0.717792 -0.696258 151.708 51.9554)",
    fill: "#D41D24"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(-0.717792 0.696258 -0.717792 -0.696258 87.1873 51.9554)",
    fill: "#D41D24"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 14.1245,
    height: 14.1245,
    transform: "matrix(-0.717792 0.696258 -0.717792 -0.696258 20.2766 51.9554)",
    fill: "#D41D24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000003346);
export default __webpack_public_path__ + "static/media/Group 1000003346.105827c71c1668f3890625c28a9cee82.svg";
export { ForwardRef as ReactComponent };